import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Table from '../../shared/Table/Table';
import { columns, mapData } from './TableMetadata';
import combineStyles from '../../../helpers/combineStyles';
import LayoutStyles from '../../../styles/layout';
import ButtonStyles from '../../../styles/button';
import TypographyStyles from '../../../styles/typography';
import SpacingStyles from '../../../styles/helpers/spacing';
import ListsStyle from '../__styles__/Lists.style';
import classnames from 'classnames';
import { DEFAULT_ROWS_PER_PAGE } from '../../../constants/request_constants';
import Button from '@material-ui/core/Button';
import FormModal from './modals/FormModal';

import parseQuerystring from '../../../helpers/parseQuerystring';
import LocationExceptionFilter from './LocationExceptionFilter';

const _getNewConfig = () => {
  return {
    geographicLocationName: '',
    supplierName: '',
    geographicLocationId: undefined,
    suppliers: undefined
  };
}

class LocationExceptionList extends React.PureComponent {
  state = {
    rowsPerPage: sessionStorage.getItem('BrillaRowsPerPage')
      ? parseInt(sessionStorage.getItem('BrillaRowsPerPage'), 10)
      : DEFAULT_ROWS_PER_PAGE,
    currentConfig: _getNewConfig()
  }

  componentDidMount() {
    this._fetchData();
  }

  _fetchData(params = {}) {
    this._fetchConfigs(params);
  }

  _fetchConfigs = (params = {}) => {
    const query = params || parseQuerystring(this.props)
    this.props.fetchExceptionConfigurationList({
      ...query,
      page: query.page || 1,
      perPage: this.state.rowsPerPage
    });
  }

  _handleChangePage = page => {
    this._fetchConfigs({
      page: page + 1
    });
  }

  _handleChangeFilter = params => {
    this._fetchConfigs(params);
  };

  _handleChangeRowsPerPage = rowsPerPage => {
    sessionStorage.setItem('BrillaRowsPerPage', rowsPerPage);
    this.setState({ rowsPerPage: rowsPerPage, page: 1 }, this._fetchConfigs);
  }

  _formButtonIsVisible = () => {
    return this.props.canCreateLocationExceptions;
  }

  _getTableName = () => {
    const { configs = [] } = this.props;
    return configs.length != 1
      ? 'Excepciones'
      : 'Excepción';
  }

  _openModal = (params = {}) => {
    this.props.openFormModal();
    this.setState({
      currentConfig: this._getCurrentConfig(params.config)
    });
  }

  _closeModal = () => {
    this.props.closeFormModal();
  }

  _isLoadingData = () => {
    const {
      loading = false
    } = this.props;
    return loading;
  }

  _getNewConfig = () => {
    return {
      geographicLocationName: '',
      supplierName: '',
      geographicLocationId: undefined,
      suppliers: undefined
    };
  }

  _getCurrentConfig = config => {
    return config || _getNewConfig();
  }

  _handleRowClick = config => {
    if (this.props.canUpdateLocationExceptions) {
      this._openModal({ config });
    }
  }

  render() {
    const {
      configs = [],
      meta = {},
      classes,
      geographicLocations = [],
      suppliers = [],
      modalSubmitLoading = false,
      modalDestroyLoading = false,
      createConfig,
      updateConfig,
      formModalIsOpen,
      deleteConfig,
      canDestroyLocationExceptions
    } = this.props;

    const { currentPage } = meta;

    const { rowsPerPage } = this.state;

    return (
      <div>
        <div className={classes.titleRootWrapper}>
          <h1 className={classnames(classes.headline4, classes.title)}>
            {'Excepciones por localidad'}
          </h1>
          {this._formButtonIsVisible() && (
            <Button
              className={classes.button}
              classes={{
                label: classes.buttonLabel
              }}
              variant="contained"
              color="secondary"
              onClick={() => this._openModal()}
            >
              {'Crear Exclusión'}
            </Button>
          )}
        </div>
        <div>
        <div className={classes.filterOptionsWrapper}>
            <LocationExceptionFilter
              suppliers={suppliers.filter(supplier => supplier.active)}
              geographicLocations={geographicLocations.filter(geoLocation => geoLocation.area_type !== "4")}
              onChangeFilter={this._handleChangeFilter}
            />
          </div>
        </div>
        <div>
          <Table
            name={this._getTableName()}
            columns={columns}
            data={mapData(configs)}
            onChangePage={this._handleChangePage}
            onChangePageRowsPerPage={this._handleChangeRowsPerPage}
            page={currentPage - 1}
            rowsPerPage={this.state.rowsPerPage}
            totalCount={(meta && meta.totalCount) || 0}
            loading={this._isLoadingData()}
            onClickOnRow={this._handleRowClick}
          />
        </div>
        <div>
          {
            formModalIsOpen && (
              <FormModal
                onClose={this._closeModal}
                onDelete={(params) => {
                  const { meta } = this.props;
                  const page = params.page || (meta && meta.currentPage) || 1;
                  deleteConfig({
                    ...params,
                    page: page,
                    perPage: this.state.rowsPerPage
                  });
                }}
                config={this.state.currentConfig}
                suppliers={suppliers.filter(supplier => supplier.active)}
                geographicLocations={geographicLocations.filter(geoLocation => geoLocation.area_type !== "4")}
                createConfig={createConfig}
                updateConfig={updateConfig}
                submitLoading={modalSubmitLoading}
                modalDestroyLoading={modalDestroyLoading}
                rowsPerPage={rowsPerPage}
                currentPage={currentPage}
                canDestroyLocationExceptions={canDestroyLocationExceptions}
              />
            )
          }
        </div>
      </div>
    );
  }
}

const styles = () => ({});

export default withStyles(
  combineStyles(
    LayoutStyles,
    ButtonStyles,
    TypographyStyles,
    SpacingStyles,
    ListsStyle,
    styles
  )
)(LocationExceptionList);